"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SpinnerComponent = (function () {
    function SpinnerComponent() {
        this.size = 25;
        this.tickness = 2;
        this.color = '#4f6aa7';
        this.opacity = '.1';
        this.secondColor = '';
    }
    SpinnerComponent.prototype.ngOnInit = function () {
        var c = this.hexToRgb(this.color);
        this.secondColor = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ', ' + this.opacity + ')';
    };
    SpinnerComponent.prototype.hexToRgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };
    return SpinnerComponent;
}());
__decorate([
    core_1.Input(),
    core_1.HostBinding('style.width.px'),
    core_1.HostBinding('style.height.px'),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "size", void 0);
__decorate([
    core_1.Input(),
    core_1.HostBinding('style.borderWidth.px'),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "tickness", void 0);
__decorate([
    core_1.Input(),
    core_1.HostBinding('style.borderTopColor'),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "color", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "opacity", void 0);
__decorate([
    core_1.HostBinding('style.borderBottomColor'),
    core_1.HostBinding('style.borderLeftColor'),
    core_1.HostBinding('style.borderRightColor'),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "secondColor", void 0);
SpinnerComponent = __decorate([
    core_1.Component({
        selector: 'spinner',
        template: '',
        styles: ["\n    @keyframes spin {\n      from {transform: rotate(0deg);}\n      to {transform: rotate(360deg);}\n    }\n\n    :host {\n      position:relative;\n      box-sizing: border-box;\n      display:inline-block;\n      padding:0px;\n      border-radius:100%;\n      border-style:solid;\n      animation: spin 0.8s linear infinite;\n    }\n\n    :host .margins {\n        margin: 0px 10px;\n    }\n  "]
    })
], SpinnerComponent);
exports.SpinnerComponent = SpinnerComponent;
//# sourceMappingURL=angular2-spinner.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-spinner/dist/angular2-spinner.js
// module id = 18
// module chunks = 3